import req from './index'


//获取风险处理员列表
export const GetHandlerUserList = (params) => {
    return req.get('api/admin.php?s=Admin.User.RiskHandlerUser_List', params)
}

//获取风险处理员详细信息
export const GetHandlerUserInfo= (params) => {
    return req.get('api/admin.php?s=Admin.User.RiskHandlerUser_Info', params)
}

//风险处理员更新或添加
export const SetHandlerUser= (params) => {
    return req.post('api/admin.php?s=Admin.User.RiskHandlerUser_Set', params)
}

// 风险处理员状态更新
export const SetState= (params) => {
    return req.post('api/admin.php?s=Admin.User.RiskHandlerUser_Status', params)
}